import { render, staticRenderFns } from "./MultiPackageLoader.vue?vue&type=template&id=037a1414"
import script from "./MultiPackageLoader.vue?vue&type=script&lang=js"
export * from "./MultiPackageLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports